module.exports = __webpack_public_path__ + "static/media/yui-hatano.d22621f5.jpg";